import Vue from 'vue'
import request from '@/utils/request'

// 关键修复：在小程序 webview 中，wx 对象可能延迟注入
// 因此不在模块加载时引入 weixin-js-sdk，而是在运行时动态检查

// 动态获取 wx 对象的函数
function getWxObject() {
  if (typeof window === 'undefined') {
    return null
  }
  
  // 优先使用官方 JSSDK 注入的 window.wx（通过 <script> 标签引入 jweixin-1.3.2.js）
  // 官方文档要求：在小程序 web-view 中必须引入 https://res.wx.qq.com/open/js/jweixin-1.3.2.js
  // 这个脚本会注入 window.wx 对象，包含 wx.miniProgram 接口
  if (window.wx) {
    console.log('[Wx组件] 使用官方 JSSDK 注入的 window.wx')
    return window.wx
  }
  
  // 如果官方 JSSDK 未加载，尝试使用 weixin-js-sdk npm 包（用于微信公众号）
  try {
    const wxSDK = require('weixin-js-sdk')
    const wx = wxSDK.default || wxSDK
    console.log('[Wx组件] 使用 weixin-js-sdk npm 包')
    return wx
  } catch (e) {
    console.warn('[Wx组件] 无法加载 weixin-js-sdk:', e)
    return null
  }
}

// 导出一个获取 wx 对象的函数，而不是直接导出 wx 对象
// 这样可以在运行时动态获取，而不是在模块加载时获取
export function getWx() {
  return getWxObject()
}

// 为了兼容旧代码，也导出一个 wx 对象（延迟初始化）
let wx = null

export async function initWechatWebview() {
  // 暂时禁用微信SDK初始化
  console.log('已暂时禁用')
  return false

  // 初始化逻辑暂时注释掉
  /*
  try {
    const url = window.location.href.split('#')[0]
    // 后端请求获取签名
    const { data } = await request({
      url: '/wx/jsSdkInit?url=' + url,
      method: 'get'
    })
    const wxObj = getWx()
    if (!wxObj) {
      console.warn('[Wx组件] wx 对象不可用，无法初始化')
      return false
    }
    wxObj.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: data.appId, // 必填，公众号的唯一标识
      timestamp: data.timestamp, // 必填，生成签名的时间戳
      nonceStr: data.nonceStr, // 必填，生成签名的随机串
      signature: data.signature, // 必填，签名
      jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表
    })
    wxObj.error(function(res) {
      // alert('wx error: ' + res)
      // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
    })
  } catch (e) {
    console.log(e)
    return false
  }
  return true
  */
}
Vue.prototype.wxJsSdkInit = initWechatWebview
